import { getEventsByCategory } from '@v2/services/getEventsByCategory';
import type { EventResponse } from '@v2/types';

type PopularEventsResponse = {
  events?: EventResponse[];
} | null;

type PopularEventsFetcher = (request: {
  categoryName: string;
  orderBy: string;
  concerts: boolean;
  withVenueImages: boolean;
  page: number;
  perPage?: number;
}) => Promise<PopularEventsResponse>;

type PopularEventsOptions = {
  categoryNames: string[];
  concerts: boolean;
  perPage?: number;
  maxEvents?: number;
};

export const getPopularLeagueEvents = async (
  { categoryNames, concerts, perPage, maxEvents }: PopularEventsOptions,
  fetchEvents: PopularEventsFetcher = getEventsByCategory
) => {
  const responses = await Promise.allSettled(
    categoryNames.map((categoryName) =>
      fetchEvents({
        categoryName,
        orderBy: 'events.popularity_score DESC',
        concerts,
        withVenueImages: true,
        page: 1,
        perPage,
      })
    )
  );
  const eventsById = new Map<number, EventResponse>();

  responses.forEach((response) => {
    if (response.status !== 'fulfilled') return;

    response.value?.events?.forEach((event) => {
      if (!eventsById.has(event.id)) eventsById.set(event.id, event);
    });
  });

  const events = Array.from(eventsById.values());
  return maxEvents ? events.slice(0, maxEvents) : events;
};
